<template>
  <input
    class="soha-switch"
    :disabled="disable"
    type="checkbox"
    :name="name"
    :checked="isChecked"
    :value="value"
    @change="updateInput"
  >
</template>

<script>
import { computed } from 'vue';
import "@/assets/css/components/base/switch.css";

export default {
  name: "CustomSwitch",

  props: {
    value: { type: String },
    name: String,
    modelValue: { default: "" },
    trueValue: { default: true },
    falseValue: { default: false },
    disable: {
      default: false,
      type: Boolean,
    },
  },

  emits: ['update:modelValue', 'change'],

  setup(props, { emit }) {
    const isChecked = computed(() => {
      if (Array.isArray(props.modelValue)) {
        return props.modelValue.includes(props.value);
      }
      return props.modelValue === props.trueValue;
    });

    const updateInput = (event) => {
      const checked = event.target.checked;
      
      if (Array.isArray(props.modelValue)) {
        const newValue = [...props.modelValue];
        
        if (checked) {
          newValue.push(props.value);
        } else {
          const index = newValue.indexOf(props.value);
          if (index > -1) {
            newValue.splice(index, 1);
          }
        }
        
        emit('update:modelValue', newValue);
        emit('onChange', newValue);
      } else {
        const newValue = checked ? props.trueValue : props.falseValue;
        emit('update:modelValue', newValue);
        emit('onChange', newValue);
      }
    };

    return {
      isChecked,
      updateInput
    };
  }
};
</script>